import React, { useState, useEffect } from "react";
import AttachmentSelector from "./AttachmentSelector";
import TeethPosition from "./TeethPosition";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { useGlobalStore } from "@/store";

function SidePanel3DControls({
  setAutoSave,
  dentalNotation,
  maxStepNumber,
  currentStep,
  tpLoaded,
  GLBData,
  iprOverLays,
  setIprOverlays,
  movementTable,
  parsedMovementTables,
}) {
  const { setLayout, activeControlTab, setControls3D } = useGlobalStore(
    state => ({
      setLayout: state.setLayout,
      setControls3D: state.setControls3D,
      activeControlTab: state.controls3D.activeControlTab,
    }),
  );

  const [activeTab, setActiveTab] = useState(activeControlTab);
  const { content } = useCustomTranslation();
  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };
  const onTabChange = value => {
    setActiveTab(value);
    setControls3D("activeControlTab", value);
  };
  useEffect(() => {
    onTabChange(activeControlTab);
  }, [activeControlTab]);
  return (
    <div
      className="mt-[8px] flex w-[169px] flex-col rounded-[4px] bg-white"
      onPointerEnter={() => {
        setLayout("isUI", true);
      }}
      onMouseLeave={() => {
        setLayout("isUI", false);
      }}
    >
      <div className="flex justify-center pt-[8px]">
        <button
          className={`h-[33px] w-fit ${
            activeTab === "teeth"
              ? "rounded-[1px] bg-[#F2F2F2] px-[12px] py-[8px] text-[12px] font-semibold text-black"
              : "rounded-[1px] bg-white px-[12px] py-[8px] text-[12px] font-semibold text-[#BCBCBC]"
          }`}
          onClick={() => onTabChange("teeth")}
        >
          {getContent("labels", "teeth")}
        </button>
        <button
          className={`h-[33px] w-fit ${
            activeTab === "auxiliaries"
              ? "rounded-[1px] bg-[#F2F2F2] px-[12px] py-[8px] text-[12px] font-semibold text-black"
              : "rounded-[1px] bg-white px-[12px] py-[8px] text-[12px] font-semibold text-[#BCBCBC]"
          }`}
          onClick={() => onTabChange("auxiliaries")}
        >
          {getContent("labels", "auxiliaries")}
        </button>
      </div>

      <div className="overflow-auto">
        {activeTab === "teeth" ? (
          <TeethPosition
            setAutoSave={setAutoSave}
            dentalNotation={dentalNotation}
            maxStepNumber={maxStepNumber}
            currentStep={currentStep}
            tpLoaded={tpLoaded}
            GLBData={GLBData}
            iprOverLays={iprOverLays}
            setIprOverlays={setIprOverlays}
            movementTable={movementTable}
            parsedMovementTables={parsedMovementTables}
          />
        ) : (
          <AttachmentSelector setAutoSave={setAutoSave} />
        )}
      </div>
    </div>
  );
}

export default SidePanel3DControls;
